webpackJsonp([185166916064630],{

/***/ 345:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Put recipe here</p>","frontmatter":{"date":"July 12, 2017","path":"/blog/non-stick-cookie-dough-recipe","title":"Non-Stick Cookie Dough Recipe","image":"/images/ssl.jpg"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-non-stick-cookie-dough-recipe-b0ffeea8974bb815c5ca.js